import { render, staticRenderFns } from "./CardIntegracao.vue?vue&type=template&id=c226b22c&scoped=true"
import script from "./CardIntegracao.vue?vue&type=script&lang=js"
export * from "./CardIntegracao.vue?vue&type=script&lang=js"
import style0 from "./CardIntegracao.vue?vue&type=style&index=0&id=c226b22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c226b22c",
  null
  
)

export default component.exports